import { Injectable } from "@angular/core";
import { LocalStorageService } from "angular-web-storage";

/* Persists which display device code was created on THIS physical
 * device. AP/AN displays only offer View Display on the device whose
 * localStorage holds their code; claiming a display on another device
 * rotates it to a fresh code, so exactly one device owns a display at a
 * time — and a device holds at most one code (it can only ever be one
 * display), so saving a code replaces any previous one. */
@Injectable({
  providedIn: "root",
})
export class DeviceStorageService {
  private static STORAGE_KEY_DEVICE_CODES = "ownedDisplayDeviceCodes";
  private static STORAGE_KEY_AUTO_OPEN = "autoOpenDisplayMirror";

  constructor(private storage: LocalStorageService) {}

  getOwnedDeviceCodes(): string[] {
    const codes = this.storage.get(
      DeviceStorageService.STORAGE_KEY_DEVICE_CODES,
    );
    return Array.isArray(codes) ? codes : [];
  }

  ownsDevice(deviceCode: string): boolean {
    if (!deviceCode) {
      return false;
    }
    return this.getOwnedDeviceCodes().indexOf(deviceCode) !== -1;
  }

  saveDeviceCode(deviceCode: string) {
    if (!deviceCode) {
      return;
    }
    // single slot: this device can only ever be one display
    this.storage.set(DeviceStorageService.STORAGE_KEY_DEVICE_CODES, [
      deviceCode,
    ]);
  }

  /* Auto-open: when set, launching the app skips the home page and goes
   * straight to the display view of the owned display. The stored value
   * is the userMirror snapshot the display view needs. */
  getAutoOpenMirror(): any {
    return this.storage.get(DeviceStorageService.STORAGE_KEY_AUTO_OPEN);
  }

  setAutoOpenMirror(userMirror: any) {
    if (!userMirror || !userMirror.mirror) {
      return;
    }
    this.storage.set(DeviceStorageService.STORAGE_KEY_AUTO_OPEN, userMirror);
  }

  clearAutoOpenMirror() {
    this.storage.remove(DeviceStorageService.STORAGE_KEY_AUTO_OPEN);
  }
}
